/**
 * Enum representing various frontend log types.
 */
export enum FRONTEND_LOG_TYPE {
	ERROR = 'ERROR',
	WARN = 'WARN'
}

/**
 * Domain model for a frontend log.
 *
 * @author Jesse Bloomster e020902
 */
export class FrontendLog {
	constructor(
		public type: FRONTEND_LOG_TYPE,
		public message?: string,
		public stackTrace?: string
	) {}
}
